import React from 'react';
import $ from "jquery";
import CommonUtils from '../../util/CommonUtils';

const DownloadReport = (props) => {

    function getReport(url) {
        if ($('.download-pdf').hasClass('fa-spin'))
            return;

        console.log(url);

        $('.download-pdf').toggleClass('far fa-file-pdf text-danger fa fa-spin fa-lg fa-circle-notch mr-2 text-primary');
        CommonUtils.ajax({
            url: url,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: null
        }).then(
            (res) => {
                $('.download-pdf').toggleClass('far fa-file-pdf text-danger fa fa-spin fa-lg fa-circle-notch mr-2 text-primary');
                if (res.status && res.status.code === 200) {
                    let a = document.createElement('a');
                    a.href = res.data.signed_url;
                    document.body.appendChild(a);
                    a.click()
                    $(a).remove();
                }
            },
            (err) => {
                $('.download-pdf').toggleClass('far fa-file-pdf text-danger fa fa-spin fa-lg fa-circle-notch mr-2 text-primary');
            });
    }

    return (
        <span rel="noopener noreferrer" onClick={() => { getReport(props.report_url); }} className="btn btn-white btn-sm" >
            <i className="far fa-file-pdf text-danger download-pdf"></i> Download PDF
        </span>
    );
}
export default DownloadReport;
